export const MEDICAL_HISTORY_CONTAINER = 'MEDICAL_HISTORY_CONTAINER';
